<template>
  <div class="system">
    <div class="container">
      
      <filters-alarms :settings="settings" :select-devices="false" @get-alarms="getAlarms" @reset-alarms="resetAlarms" @change-tab="changeTab"></filters-alarms>

      <div class="row">
        <div v-if="getData" id="alarms-datatable" class="col-md-12">
          <alarms-datatable :key="getData" :tab="tab" page="acquisitions" :settings="settings" :get-data="getData"></alarms-datatable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import FiltersAlarms from '@/components/Filters/Alarms.vue';
  import AlarmsDatatable from '@/components/AlarmsDatatable.vue';
  
  export default {
    name: "system",
    
    components: {FiltersAlarms , AlarmsDatatable},

    data() {
      return {
        tab: null,
        settings: {
          parametersAttributes: { //Obbligatorio
            columns: {value: 'col-md-6'},
            classes: {value: 'form-control'},
            options: {value: []},
            idField: {value: 'checkId'},
            labelField: {value: 'description'},
            value: {value: null}
          },
          lowerboundAttributes: {
            columns: {value: 'col-md-6'},
            classes: {value: 'form-control form-datepicker'},
            label: {value: 'Da'},
            placeholder: {value: 'Seleziona una data'},
            required: {value: false},
            dateFormat: {value: 'DD/MM/YYYY'},
            disabled: {value: false},
            value: {value: null}
          },
          upperboundAttributes: {
            columns: {value: 'col-md-6'},
            classes: {value: 'form-control form-datepicker'},
            label: {value: 'A'},
            placeholder: {value: 'Seleziona una data'},
            required: {value: false},
            dateFormat: {value: 'DD/MM/YYYY'},
            disabled: {value: false},
            value: {value: null}
          }
        },

        getData: null
      }
    },

    methods: {
      getAlarms() {
        this.getData = (((1+Math.random())*0x10000)|0).toString(16).substring(1);
      },
      
      resetAlarms() {
        this.getData = null;
      },

      changeTab(tab) {
        this.tab = tab; 
        
        this.resetAlarms()
      }
    }
  };
</script>
